import React from 'react';

export default () => (
  <svg width="61" height="61" viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
    <g fillRule="nonzero" fill="#E4F1FD">
      <path d="M30.123 0C14.718 0 15.679 6.814 15.679 6.814l.018 7.06h14.7v2.118H9.857S0 14.852 0 30.706C0 46.56 8.604 45.998 8.604 45.998h5.135V38.64s-.277-8.776 8.466-8.776h14.581s8.192.135 8.192-8.075V8.215S46.222 0 30.123 0zm-8.106 4.747c.701 0 1.374.284 1.87.79s.775 1.192.774 1.908c0 .715-.278 1.402-.774 1.908s-1.169.79-1.87.789a2.616 2.616 0 0 1-1.871-.79 2.723 2.723 0 0 1-.774-1.907c0-.716.278-1.402.774-1.908a2.616 2.616 0 0 1 1.87-.79z" />
      <path d="M30.878 61c15.405 0 14.443-6.814 14.443-6.814l-.017-7.059H30.603v-2.12h20.54S61 46.149 61 30.295s-8.604-15.292-8.604-15.292h-5.135v7.357s.277 8.776-8.467 8.776h-14.58S16.022 31 16.022 39.21v13.575S14.778 61 30.877 61zm8.106-4.747a2.616 2.616 0 0 1-1.871-.79 2.723 2.723 0 0 1-.774-1.907c0-.716.278-1.402.774-1.908a2.616 2.616 0 0 1 1.87-.79c.702 0 1.375.284 1.871.79s.775 1.192.774 1.908c0 .715-.278 1.402-.774 1.908s-1.169.79-1.87.789z" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/python.es6.js